import React from 'react'

import classNames from 'classnames'

import styles from './cardFullWidth.module.scss'

type OwnProps = React.HTMLAttributes<HTMLDivElement> & {
  children: $TSFixMe
  roundCorners?: boolean
  withShadow?: boolean
  className?: string
}

type Props = OwnProps

const CardFullWidth = ({ roundCorners, children, withShadow = false, className, ...props }: Props) => {
  return (
    <div
      className={classNames(className, styles.card, { [styles.round]: roundCorners }, { [styles.shadow]: withShadow })}
      {...props}
    >
      {children}
    </div>
  )
}

export default CardFullWidth
